import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ApiUrl } from '../../API/Api';


const Intervention = () => {
  const location = useLocation();
  const url = location.pathname;
  const [id, setId] = useState();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const path = {
      '/kolping': 21,
      '/kutti-koottam': 22,
      '/child-parliment': 23,
      '/child-sponsorship' : 24,
      '/jeevamirdam' : 25,
      '/jeevasurabi' : 26,
      '/afford' : 27,
      '/spinsters' : 28,
      '/need-child' : 29,
      '/relief-assist' : 30,
    };
    setId(path[url] ? path[url] : url);
  }, [url]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${ApiUrl}/get/Pages`);
        const newPages = response?.data?.pages;

        localStorage.setItem('Pages', JSON.stringify(newPages));

        setData(newPages);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="text-center mt-5"><b><center>Loading...</center></b></div>;
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-center mt-5">
        <b><center>No Data Available</center></b>
      </div>
    );
  }

  const filterdata = data.filter((item) => item.id === id);

  return (
    <>
      <div className="container subpage">
        <div className="row">
          <div className="col-lg-12">
            {filterdata?.map((item) => (
              <div key={item.id} className="custom-card-body">
                <h1 className="text-center mt-4">{item.title}</h1>
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${item.content}`,
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Intervention;